export const GET_DELIVERYMAN_PRE_REGISTER = 'GET_DELIVERIES_LIST';
export enum ENUM_TITLES_SECTION {
  PERSONAL_DATA = 'Dados pessoais',
  BANK_DATA = 'Dados bancários',
  ID_DOCUMENT = 'Documento de Identidade (RG)',
  VEHICLE_REGISTRATION = 'Certificado de Registro e Licenciamento de Veículo (CRLV)',
  SELFIE = 'Selfie (sem documento)',
  SELFIE_WHIT_DOCUMENT = 'Selfie (com documento)',
  DRIVER_LICENSE = 'Carteira de motorista (CNH)',
}

export enum ENUM_VEHICLE_TYPE {
  MOTO = 'MOTO',
  CARRO = 'CARRO',
  BICICLETA = 'BICICLETA',
}
